/* Native scrolling and progressive enhancement for Gummies Bundle 10. */
(() => {
  'use strict';
  if (window.fb10SectionsReady) return;
  window.fb10SectionsReady = true;
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initializeCarousel = (section) => {
    if (section.dataset.fb10Ready) return;
    section.dataset.fb10Ready = 'true';
    const track = section.querySelector('.fb10-track');
    const previous = section.querySelector('[data-fb10-prev]');
    const next = section.querySelector('[data-fb10-next]');
    const position = section.querySelector('.fb10-position');
    let frame = 0;
    const sync = () => {
      frame = 0;
      const cards = [...track.children];
      section.dataset.fb11Scrollable = String(track.scrollWidth > track.clientWidth + 2);
      const index = cards.reduce((best, card, i) => Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft) < Math.abs(cards[best].offsetLeft - cards[0].offsetLeft - track.scrollLeft) ? i : best, 0);
      position.textContent = `${index + 1} / ${cards.length}`;
      previous.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
    const move = (direction) => {
      const gap = parseFloat(getComputedStyle(track).columnGap) || 20;
      track.scrollBy({left: direction * (track.firstElementChild.getBoundingClientRect().width + gap), behavior: reducedMotion() ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('keydown', (event) => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1);
    });
    track.addEventListener('scroll', schedule, {passive: true});
    const observer = new ResizeObserver(schedule);
    observer.observe(track);
    section.fb10Destroy = () => { observer.disconnect(); cancelAnimationFrame(frame); };
    sync();
  };
  const initializeReviews = (section) => {
    if (section.dataset.fb10Ready) return;
    section.dataset.fb10Ready = 'true';
    const grid = section.querySelector('.fb10-review-grid');
    const cards = [...grid.children];
    const initial = Number(section.dataset.initialCount) || 12;
    const more = section.querySelector('[data-fb10-more]');
    const dialog = section.querySelector('[data-fb10-dialog]');
    const email = section.querySelector('[data-fb10-email]');
    let rating = 'all', filter = 'all', limit = initial, frame = 0;
    const fit = () => {
      frame = 0;
      const style = getComputedStyle(grid);
      const gap = parseFloat(style.rowGap) || 8;
      const row = parseFloat(style.gridAutoRows) || 4;
      const spans = cards.filter(card => !card.hidden).map(card => [card, Math.ceil((card.getBoundingClientRect().height + gap) / (row + gap))]);
      spans.forEach(([card, span]) => {
        const value = `span ${span}`;
        if (card.style.gridRowEnd !== value) card.style.gridRowEnd = value;
      });
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(fit); };
    const observer = new ResizeObserver(schedule);
    cards.forEach(card => observer.observe(card));
    observer.observe(grid);
    section.fb10Destroy = () => { observer.disconnect(); cancelAnimationFrame(frame); };
    const update = () => {
      const sort = section.querySelector('select').value;
      const matches = cards.filter(card => (rating === 'all' || Math.floor(Number(card.dataset.rating)) === Number(rating)) && (filter === 'all' || card.dataset.photo === 'true'));
      if (sort !== 'original') matches.sort((a,b) => (Number(b.dataset.rating) - Number(a.dataset.rating)) * (sort === 'high' ? 1 : -1));
      cards.forEach(card => { card.hidden = true; });
      matches.forEach((card, index) => { card.hidden = index >= limit; grid.append(card); });
      more.hidden = limit >= matches.length;
      section.querySelector('.fb10-reviews-empty').hidden = matches.length > 0;
      section.querySelector('.fb10-result-count').textContent = `Showing ${Math.min(limit, matches.length)} of ${matches.length} reviews`;
      schedule();
    };
    section.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || !section.contains(button)) return;
      if (button.hasAttribute('data-fb10-more')) { limit += 6; update(); }
      if (button.hasAttribute('data-fb10-filters')) {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        section.querySelector('.fb10-toolbar').hidden = !open;
      }
      if (button.dataset.rating || button.dataset.filter) {
        const key = button.dataset.rating ? 'rating' : 'filter';
        if (key === 'rating') rating = button.dataset.rating; else filter = button.dataset.filter;
        section.querySelectorAll(`button[data-${key}]`).forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        limit = initial; update();
      }
      if (button.hasAttribute('data-fb10-expand')) {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        button.querySelector('.fb10-read-full').textContent = open ? 'Show less' : 'Read full review';
        schedule();
      }
      if (button.hasAttribute('data-fb10-photo')) {
        const card = button.closest('[data-fb10-card]');
        const content = dialog.querySelector('[data-fb10-dialog-content]');
        const photo = button.querySelector('img').cloneNode(true);
        photo.className = 'fb10-dialog-photo'; photo.sizes = '(max-width: 749px) 90vw, 650px';
        const body = document.createElement('div'); body.className = 'fb10-card-body';
        const name = document.createElement('h2'); name.id = dialog.getAttribute('aria-labelledby'); name.textContent = card.querySelector('.fb10-review-author strong').textContent;
        const text = document.createElement('p'); text.textContent = card.querySelector('.fb10-review-excerpt').textContent;
        body.append(name,card.querySelector('.fb10-stars').cloneNode(true),text);
        content.replaceChildren(photo,body); dialog.showModal();
      }
      if (button.hasAttribute('data-fb10-write')) email.showModal();
      if (button.hasAttribute('data-fb10-close')) button.closest('dialog').close();
    });
    section.querySelector('select').addEventListener('change', () => {limit = initial; update();});
    [dialog,email].forEach(modal => modal.addEventListener('click', event => {
      if (event.target !== modal) return;
      const rect = modal.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) modal.close();
    }));
    update();
  };
  const initialize = (root = document) => {
    root.querySelectorAll('[data-fb10-carousel]').forEach(initializeCarousel);
    root.querySelectorAll('[data-fb10-reviews]').forEach(initializeReviews);
    root.querySelectorAll('[data-fb10-offer]').forEach(button => {
      if (button.dataset.fb10Ready) return;
      button.dataset.fb10Ready = 'true';
      button.addEventListener('click', () => {
        const offer = document.querySelector('[data-o12-scroll-target]') || document.querySelector('[data-o12-bundle]');
        if (!offer) return;
        offer.setAttribute('tabindex','-1'); offer.focus({preventScroll:true});
        const heading = offer.querySelector('.o12-bundle__heading') || offer;
        const top = heading.getBoundingClientRect().top + window.scrollY - window.innerHeight * 0.3;
        window.scrollTo({top: Math.max(0, top), behavior: reducedMotion() ? 'auto' : 'smooth'});
      });
    });
  };
  const ready = () => {
    initialize();
    if (document.body.matches('.template-product-gummies-custom-bundle-11, .template-product-gummies-custom-bundle-12')) {
      document.querySelectorAll('.shopify-section[id$="__collapsible_content_f7abnC"] .accordion__content p').forEach(paragraph => {
        if (!paragraph.textContent.trim() && !paragraph.querySelector('img, video')) paragraph.classList.add('fb10-empty-paragraph');
      });
      if (matchMedia('(max-width: 749px)').matches) {
        document.querySelectorAll('.nuora-footer-390__menu').forEach(menu => { menu.open = false; });
      }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',ready,{once:true}); else ready();
  document.addEventListener('shopify:section:load',event => initialize(event.target));
  document.addEventListener('shopify:section:unload',event => {
    event.target.querySelectorAll('[data-fb10-ready]').forEach(section => section.fb10Destroy?.());
  });
})();
